import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NUMBER_0 } from '~shared/constants';

@Component({
  selector: 'app-product-discount-label',
  templateUrl: './product-discount-label.component.html',
  styleUrls: ['./product-discount-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDiscountLabelComponent {
  @Input() msrpDiscount: string | number;
  @Input() fromProductCard: boolean = false;
  number_0 = NUMBER_0;
}
